import React from 'react';
import { formatTranslation } from 'intl';
import { makeStyles } from '@mui/styles';
import { useIntl } from 'react-intl';
import BrowserIcon from 'assets/icons/browser.svg?react';
import { InspectionTemplateTranslationKeys } from 'intl/keys';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '100px',
    width: '100%',
  },
  title: {
    fontFamily: 'Archivo',
    fontSize: '1.5rem',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '26px',
    letterSpacing: '0em',
    textAlign: 'center',
    marginTop: '41px',
    marginBottom: '24px',
  },
});

export function SelectTemplatePrompt(): React.ReactElement {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.wrapper}>
      <BrowserIcon />
      <span className={classes.title}>
        {formatTranslation(intl, InspectionTemplateTranslationKeys.listSelectPrompt)}
      </span>
    </div>
  );
}
